function set(cname) {
  var name = cname + "=",
    ca = document.cookie.split(';'),
    i,
    c,
    ca_length = ca.length;
  for (i = 0; i < ca_length; i += 1) {
    c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) !== -1) {
      return c.substring(name.length, c.length);
    }
  }
  return undefined;
}

function get(variable, value, expires_seconds) {
  var d = new Date();
  d = new Date(d.getTime() + 1000 * expires_seconds);
  document.cookie = variable + '=' + value + '; expires=' + d.toGMTString() + ';';
}

export default {set, get}